<div class="user-roster">
    <header class="user-roster-head">
        <div class="user-roster-copy">
            <h1>Agenti</h1>
            <p>Elenco degli agenti registrati sulla piattaforma, con codice agente e recapiti.</p>
        </div>
        <span class="user-roster-count" *ngIf="!loading">{{ totalRecords }} agenti</span>
    </header>

    <form class="user-roster-toolbar" (submit)="$event.preventDefault(); applyFilters()">
        <input
            type="search"
            class="form-control form-control-solid"
            [(ngModel)]="textFilter"
            name="agentSearch"
            placeholder="Cerca nome, cognome o email"
            (keyup.enter)="applyFilters()"
        />
        <button
            type="button"
            class="btn welldone-btn-gray user-filter-trigger"
            [class.is-open]="!!activeFilterCount"
            (click)="filtersPanel.toggle($event)"
        >
            <i class="bi bi-funnel" aria-hidden="true"></i>
            Filtri
            <span class="user-filter-badge" *ngIf="activeFilterCount">{{ activeFilterCount }}</span>
        </button>
        <button type="submit" class="btn btn-primary">Cerca</button>
        <button type="button" class="btn btn-reset-link" *ngIf="hasActiveQuery" (click)="resetAll()">Reset</button>
    </form>

    <p-overlayPanel #filtersPanel [dismissable]="false" styleClass="user-filter-popover">
        <div class="user-filter-form">
            <div class="user-filter-field">
                <label class="form-label" for="agent-status">Stato</label>
                <p-multiSelect
                    inputId="agent-status"
                    styleClass="wisper-multiselect"
                    panelStyleClass="wisper-multiselect-panel"
                    [options]="statusOptions"
                    [(ngModel)]="selectedStatusIds"
                    optionLabel="name"
                    optionValue="id"
                    placeholder="Tutti"
                    display="chip"
                    [showToggleAll]="false"
                    [style]="{'width':'100%'}"
                    appendTo="body"
                ></p-multiSelect>
            </div>

            <div class="user-filter-field">
                <label class="form-label" for="agent-sort">Ordina per</label>
                <p-dropdown
                    inputId="agent-sort"
                    styleClass="wisper-select"
                    panelStyleClass="wisper-select-panel"
                    [options]="sortOptions"
                    [(ngModel)]="sortBy"
                    optionLabel="name"
                    optionValue="id"
                    [style]="{'width':'100%'}"
                    appendTo="body"
                ></p-dropdown>
            </div>

            <div class="user-filter-actions">
                <button type="button" class="btn btn-reset-link" (click)="clearAdvancedFilters()">Azzera</button>
                <button type="button" class="btn btn-primary" (click)="applyFilters()">Applica</button>
            </div>
        </div>
    </p-overlayPanel>

    <p-table
        [value]="agents"
        dataKey="id"
        [lazy]="true"
        [paginator]="true"
        [rows]="rows"
        [first]="first"
        [totalRecords]="totalRecords"
        [loading]="loading"
        [rowsPerPageOptions]="[30,50,100]"
        [rowHover]="true"
        responsiveLayout="scroll"
        styleClass="user-roster-table"
        paginatorDropdownAppendTo="body"
        currentPageReportTemplate="{first}–{last} di {totalRecords}"
        [showCurrentPageReport]="true"
        (onLazyLoad)="loadAgents($event)"
    >
        <ng-template pTemplate="header">
            <tr>
                <th>Agente</th>
                <th>Codice</th>
                <th>Partita IVA</th>
                <th>Telefono</th>
                <th>Stato</th>
                <th class="user-col-actions">Azioni</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
            <tr class="user-roster-row" (click)="openAgent(row)">
                <td>
                    <div class="user-identity">
                        <app-identity-avatar
                            [imageUrl]="row.image"
                            [initials]="initials(row)"
                            [colorKey]="row.id || row.email || (row.firstName + row.lastName)"
                        ></app-identity-avatar>
                        <div class="user-identity-text">
                            <span class="user-name">{{ row.firstName }} {{ row.lastName }}</span>
                            <span class="user-email">{{ row.email }}</span>
                        </div>
                    </div>
                </td>
                <td>
                    <span class="agent-code" *ngIf="row.number != null && row.number !== ''; else dash">
                        <i class="bi bi-hash" aria-hidden="true"></i>{{ row.number }}
                    </span>
                </td>
                <td>
                    <span class="agent-mono" *ngIf="row.vat; else dash">{{ row.vat }}</span>
                </td>
                <td>
                    <a class="agent-phone" *ngIf="row.phone; else dash" [href]="'tel:' + row.phone" (click)="$event.stopPropagation()">
                        <i class="bi bi-telephone" aria-hidden="true"></i>
                        {{ row.phone }}
                    </a>
                </td>
                <td>
                    <span class="badge user-icon-badge" [ngClass]="statusBadgeClass(row.status)">
                        <i class="bi" [ngClass]="statusIcon(row.status)" aria-hidden="true"></i>
                        {{ statusLabel(row.status) }}
                    </span>
                </td>
                <td class="user-col-actions" (click)="$event.stopPropagation()">
                    <div class="user-actions">
                        <a
                            class="btn welldone-btn-gray"
                            title="Modifica agente"
                            [routerLink]="['/admins/agents', row.id]"
                        >
                            <i class="bi bi-pencil" aria-hidden="true"></i>
                        </a>
                        <button
                            *ngIf="row.status === 'active'"
                            type="button"
                            class="btn welldone-btn-gray"
                            title="Accedi come agente"
                            (click)="loginAs(row.email, row.id)"
                        >
                            <i class="bi bi-box-arrow-in-right" aria-hidden="true"></i>
                        </button>
                    </div>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="loadingbody">
            <tr *ngFor="let row of skeletonRows">
                <td>
                    <div class="user-identity">
                        <div class="user-skel user-skel-mark"></div>
                        <div class="user-identity-text">
                            <div class="user-skel user-skel-title"></div>
                            <div class="user-skel user-skel-line"></div>
                        </div>
                    </div>
                </td>
                <td><div class="user-skel user-skel-chip"></div></td>
                <td><div class="user-skel user-skel-company"></div></td>
                <td><div class="user-skel user-skel-company"></div></td>
                <td><div class="user-skel user-skel-chip"></div></td>
                <td class="user-col-actions">
                    <div class="user-actions">
                        <div class="user-skel user-skel-btn"></div>
                        <div class="user-skel user-skel-btn"></div>
                    </div>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="6" class="user-empty">Nessun agente trovato. Prova a cambiare ricerca o filtri.</td>
            </tr>
        </ng-template>
    </p-table>
</div>

<ng-template #dash>
    <span class="user-muted">—</span>
</ng-template>
